import { Injectable } from '@angular/core';
import { ValidatorFn, AbstractControl, ValidationErrors, FormGroup, FormControl } from '@angular/forms';
import { BaseValidator } from 'src/app/validators/base-validator'

@Injectable({
  providedIn: 'root'
})

export class WordsValidator extends BaseValidator {

  constructor() {
    super();
  }

  minWords(minWordsValue): ValidatorFn {
    return (control: FormControl): { [key: string]: boolean } | null => {
      if (control) {
        const controlName = this.getControlName(control);
        if (controlName) {
          const controlValue = control.parent && control.parent.get(controlName) ? control.parent.get(controlName).value : '';

          const wordsArr = controlValue ? controlValue.split(' ') : [];

          if (wordsArr.length < minWordsValue) {
            return { invalidMinWords: true };
          } else {
            return null;
          }
        }
      }
    };
  }

  maxWords(maxWordsValue): ValidatorFn {
    return (control: FormControl): { [key: string]: boolean } | null => {
      if (control) {
        const controlName = this.getControlName(control);
        if (controlName) {
          const controlValue = control.parent && control.parent.get(controlName) ? control.parent.get(controlName).value : '';

          const wordsArr = controlValue ? controlValue.split(' ') : [];

          if (wordsArr.length > maxWordsValue) {
            return { invalidMaxWords: true };
          } else {
            return null;
          }
        }
      }
    };
  }
}
